/**
 * Label for the outbound link to a ticket's system of record.
 *
 * Derived from the destination host rather than from the stored `sourceSystem`
 * field. That field holds the literal "Default" for every ticket, because it is
 * a Tickety API flag distinguishing the prod ticketing system from integ — it
 * carries no meaning for a reader, and showing it told the user nothing about
 * where the link went.
 *
 * Deriving from the URL also stays honest if a second source system is ever
 * ingested, which is the reason the field exists in the first place.
 */
const HOST_LABELS: Record<string, string> = {
  't.corp.amazon.com': 'View in t.corp',
  'issues.amazon.com': 'View in SIM',
  'sim.amazon.com': 'View in SIM',
};

const FALLBACK = 'View source ticket';

export function sourceLinkLabel(url?: string): string {
  if (!url) return FALLBACK;
  try {
    // Exact hostname match, so a lookalike such as t.corp.amazon.com.evil.example
    // cannot present itself as Tickety.
    return HOST_LABELS[new URL(url).hostname.toLowerCase()] ?? FALLBACK;
  } catch {
    return FALLBACK;
  }
}
